import { CobranzasService } from './../../../../services/cobranzas/cobranzas.service';
import { Component, Output, Input, EventEmitter, ViewChild } from '@angular/core';
import { MatPaginator, MatSort ,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS} from '@angular/material';
import { FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import Swal from "sweetalert2";
import { DecimalPipe,DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesStatus,MessagesDates } from '../../../../models/messages';

import {HttpErrorResponse } from '@angular/common/http';

import * as moment from 'moment';


export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "DD-MM-YYYY",
      monthYearA11yLabel: "MMMM YYYY"
    }
};

@Component({
  selector: 'app-cancelar-cobranza-judicial',
  templateUrl: './cancelar-cobranza-judicial.component.html',
  styleUrls: ['./cancelar-cobranza-judicial.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesStatus,MessagesDates,
    DatePipe,
    DecimalPipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class CancelarCobranzaJudicialComponent{

  minDate = moment();
  loading :boolean = false;
  save : boolean = false;  
  user:any;
  arrayFacturas :any=[];
  productosarr : any;
  flagCreateUpdate :boolean = false;
  titulo:string = "Cancelar cobranza judicial";
  subtitulo: any;
  isLoading:boolean;
  dataJudicial:any;
  dataEnviar:any={};

  cuotasform: FormGroup;
  unaCuota :FormGroup;
  action:string = "crear";
  
  @Input() deuda : any;
  @Output() cerrarPopUp = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<boolean>();

  form : FormGroup;
  dataSource :any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns: string[] =['checked','idComprobante','Tipo_Comprobante','Tipo_Emision','Serie','Numero','Fecha_Vencimiento','Moneda','VNPP']
  monedaElement : string;

  constructor(
              private decimalPipe: DecimalPipe,
              private msgStatus:MessagesStatus,
              private msgTitulos : MessagesTitles,
              private datepipe :DatePipe,
              private cobranzasService : CobranzasService){
    
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.dataJudicial = this.cobranzasService.dataJudicial;
    this.subtitulo = this.dataJudicial.idCobranza_Judicial;
    this.form = new FormGroup({
      "idComprobante": new FormControl({ value: this.dataJudicial.idComprobante, disabled: true }),
      "Monto_Negociado": new FormControl({ value: this.dataJudicial.Monto_Negociado, disabled: true }),
      "Moneda": new FormControl(''),
      "Fecha_Pago": new FormControl(''),
      "VNPP": new FormControl(''),
      "Usuario": new FormControl(this.user.Usuario),
      "cuotas": new FormControl(false, []),
      "Numero_Cuotas": new FormControl({ value: 1, disabled: true }, [Validators.maxLength(2)]),
    })

    this.cuotasform = new FormGroup({
      Cuotas: new FormArray([
        new FormGroup({
          Fecha_de_Pago: new FormControl("", Validators.required),
          Importe: new FormControl("", [Validators.required,Validators.pattern("^[0-9.,]+$")]),
        }),
        new FormGroup({
          Fecha_de_Pago: new FormControl("", Validators.required),
          Importe: new FormControl("", [Validators.required,Validators.pattern("^[0-9.,]+$")]),
        })
      ]),
      Estado: new FormControl("R", [])
    });

  }

  get Cuotas(): FormArray {
    return this.cuotasform.get('Cuotas') as FormArray; 
}

  CerrarPopUp(){
    this.cerrarPopUp.emit();
    if (this.save) {
    this.refresh.emit();
    }
  }


  onClick(element:any){
  this.form.controls['idComprobante'].setValue(element.idComprobante);
  this.form.controls['Monto_Negociado'].setValue(element.VNPP);
  this.form.controls['Moneda'].setValue(element.Moneda);
  this.form.controls['VNPP'].setValue(element.VNPP);
  this.form.controls['Observacion'].setValue(element.Observacion);
  }


  transformarFechas() {

    for (let index = 0; index <= this.Cuotas.length -1 ; index++) {
     
      this.cuotasform.controls["Cuotas"]["controls"][index]["controls"][
        "Fecha_de_Pago"
      ].setValue(
        this.datepipe.transform(
          this.cuotasform.controls["Cuotas"]["controls"][index]["controls"][
            "Fecha_de_Pago"
          ].value,
          "yyyy-MM-dd"
        )
      );
    }
  }
  

  crearCuotaCobranzaJudicial(){

    this.dataEnviar.cuotas = [];
    this.dataEnviar.idCobranza_Judicial =  this.dataJudicial.idCobranza_Judicial;
    this.dataEnviar.idComprobante =  this.dataJudicial.idComprobante;
    this.dataEnviar.montoCobrar =  this.dataJudicial.Monto_Negociado;
    this.dataEnviar.numeroCuotas =  this.form.controls['Numero_Cuotas'].value;
    this.dataEnviar.usuario =  this.user.Usuario;
    
    if (this.form.controls["cuotas"].value == true) {
      
      let ultimaCuota = this.Cuotas.length -1;
      let penultimaCuota = this.Cuotas.length -2;

      let ultimaFechaCuota = this.cuotasform.controls["Cuotas"]["controls"][ultimaCuota]["controls"]["Fecha_de_Pago"].value;
      let penultimaFechaCuota = this.cuotasform.controls["Cuotas"]["controls"][penultimaCuota]["controls"]["Fecha_de_Pago"].value;

      if (this.datepipe.transform(ultimaFechaCuota,'yyyy-MM-dd')< this.datepipe.transform(penultimaFechaCuota,'yyyy-MM-dd')) {
        Swal.fire({
          title: "ERROR",
          text: "La Fecha de la última cuota no puede ser menor a la primera fecha de pago",
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
        return;
      }
  
      let pagos : any = 0;
  
      for (let index = 0; index < this.Cuotas.length; index++) {
        let p  = this.cortarComa(this.cuotasform.controls["Cuotas"]["controls"][index]["controls"]["Importe"].value);
          
        pagos += Number(p);
      }
      
      if (pagos.toFixed(2) != this.cortarComa(this.form.controls['Monto_Negociado'].value)) {
        Swal.fire({
          title: "Error",
          text: "La suma de las cuotas es diferente al Monto Negociado",
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
        return;
      }
 

      this.transformarFechas();
      this.transformarImporteCuotas();
      for(let item of this.cuotasform.getRawValue().Cuotas){
        this.dataEnviar.cuotas.push(item);
      }
    }else{
     if (this.form.controls['Fecha_Pago'].value == '') {
      Swal.fire({
        title: "Advertencia",
        text: "Seleccione fecha de pago" ,
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      })
      return
     }  

      this.unaCuota = new FormGroup({
        Cuotas: new FormArray([
          new FormGroup({
            Fecha_de_Pago: new FormControl(this.datepipe.transform(this.form.controls['Fecha_Pago'].value,"yyyy-MM-dd")),
            Importe: new FormControl(this.dataJudicial.Monto_Negociado, []),
          }),
         ]),
      });
      
      for(let item of this.unaCuota.getRawValue().Cuotas){
        this.dataEnviar.cuotas.push(item);
      }
    }
    this.loading = true;
      this.cobranzasService.CrearCuotaCobranzaJudicial(this.dataEnviar).subscribe(
        res => {
          this.loading = false;
          this.save = true;
        },(err: HttpErrorResponse)=> {
          this.loading = false;
          this.msgStatus.getMessage(err.status);  
         
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "Cuota no guardada. "+this.msgStatus.message ,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        }
      )  
  }

  agregarCuotas() {
    this.Cuotas.push(new FormGroup({
    Fecha_de_Pago: new FormControl("", Validators.required),
        Importe: new FormControl("", [
          Validators.required,
          Validators.pattern("^^[0-9.,]+$")
        ])
      })
    );
    this.form.controls["Numero_Cuotas"].setValue(this.Cuotas.length);
}

eliminarCuotas() {
  this.Cuotas.removeAt(this.Cuotas.length -1);

  this.form.controls["Numero_Cuotas"].setValue(this.Cuotas.length);
  
}

validarCuotas(termino?: string) {
  if(this.form.controls["cuotas"].value == true){
    this.form.controls["Numero_Cuotas"].setValue(
      this.Cuotas.length
    );
  }else{
    this.form.controls["Numero_Cuotas"].setValue(1);
  }
 
}

transformarImporteCuotas() {

  for (let index = 0; index <= this.Cuotas.length -1; index++) {
    this.cuotasform.controls["Cuotas"]["controls"][index]["controls"]["Importe"].setValue(this.cortarComa(this.cuotasform.controls["Cuotas"]["controls"][index]["controls"]["Importe"].value).toFixed(2));
  }
}


tranformarDecimalCuotas(indice: number, control: any, decimal?: number) {
  let valor;
  if (decimal) {
    valor = this.decimalPipe.transform(
      this.cortarComa(
        this.cuotasform.controls["Cuotas"]["controls"][indice]["controls"][
          `${control}`
        ].value
      ),
      `1.${decimal}-${decimal}`
    );
  } else {
    valor = this.decimalPipe.transform(
      this.cortarComa(
        this.cuotasform.controls["Cuotas"]["controls"][indice]["controls"][
          `${control}`
        ].value
      ),
      `1.2-2`
    );
  }

  this.cuotasform.controls["Cuotas"]["controls"][indice]["controls"][
    `${control}`
  ].setValue(valor);
}



cortarComa(numero: any): number {
  try {
    let cortado = numero.toString().replace(/,/gi, "");
    return Number(cortado);
  } catch (error) {
    return 0;
  }
}

}